<template>
  <div :class="menuIndex == 'Home' && scrollTop <= 0 ? 'header' : 'headers'">
    <div class="layout">
      <div class="left">
        <div class="logo">
          <img @click="getHomeTap"
            :src="menuIndex == 'Home' && scrollTop <= 0 ? '../../static/image/logo2.png' : '../../static/image/logo1.png'"
            alt="">
        </div>
        <div class="menu" :style="isMenu ? showMenuStyle : hideMenuStyle">
          <ul>
            <li class="menu-item" :class="menuIndex == item.meta.name ? 'menu-item_' : ''" v-for="(item, index) in menu"
              :key="index" @click="getmenu(item, index)" v-if="item.meta.isShow">
              <p>{{ isChinese ? item.meta.title : item.meta.name }}</p>
              <div class="menu-item-line" v-if="menuIndex == item.meta.name"></div>
            </li>
          </ul>
        </div>
      </div>
      <div class="right">
        <div class="menu-box">
          <img v-if="!isMenu"
            :src="menuIndex == 'Home' && scrollTop <= 0 ? '../../static/image/is-menu.png' : '../../static/image/menu.png'"
            alt="" @click="getShowMenu">
          <img v-if="isMenu"
            :src="menuIndex == 'Home' && scrollTop <= 0 ? '../../static/image/is-gb.png' : '../../static/image/gb.png'"
            alt="" @click="getHideMenu">
        </div>
        <img class="seach-icon"
          :src="menuIndex == 'Home' && scrollTop <= 0 ? '../../static/image/seach-icon.png' : '../../static/image/isSeach.png'"
          alt="" @click="getSeach">
        <img class="interpret-icon"
          :src="menuIndex == 'Home' && scrollTop <= 0 ? '../../static/image/cn-cion.png' : '../../static/image/cns-icon.png'"
          alt="" @click="getChineseAndEnglish">
        <div class="seach" v-if="isSeach">
          <el-input placeholder="Please enter content" v-model="SeachValue"  @keyup.enter.native="getTap()" clearable>
          </el-input>
          <el-button @click="getTap">search</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    scrollTop: {
      typeof: String,
      required: true,
    },
    language: {
      typeof: String,
      required: true,
    },
  },
  data() {
    return {
      menu: [],
      menuIndex: "Home",
      SeachValue: '',
      isSeach: false,
      isChinese: false,
      isMenu: false,
      showMenuStyle: {
        display: ""
      },
      hideMenuStyle: {
        display: ""
      }
    }
  },
  watch: {
    $route() {
      this.menuIndex = this.$router.history.current.meta.name
    },
    screenWidth: function (n, o) {
      if (n <= 767) {
        this.isMenu = false
      } else {
        this.isMenu = false
      }
    }

  },
  created() {
    this.menu = this.$router.history.router.options.routes;
  },
  mounted() {
    this.screenWidth = document.body.clientWidth
    window.onresize = () => {
      //屏幕尺寸变化
      return (() => {
        this.screenWidth = document.body.clientWidth
      })()
    }
  },
  methods: {
    getmenu(item, index) {
      this.isMenu = false
      if (this.menuIndex == index) {
        return
      }
      // this.menuIndex = item.name
      this.$router.push({ name: item.name })
    },
    getSeach() {
      this.isSeach = !this.isSeach
    },
    getTap() {
      if (this.SeachValue != '') {
        this.$router.push({path: '/f5',})
        setTimeout(() => {
            this.$router.push({
            path: '/seach',
            query: {
              keyword: this.SeachValue
            }
          }).catch((err)=>{})
          this.isSeach = false
        }, 1);
      }
    },
    getHomeTap() {
      this.$router.push({
        path: '/',
      })
    },
    getChineseAndEnglish() {
        window.location.href = "http://cn.antai-energy.com"
    },
    getShowMenu() {
      this.isMenu = true
      this.showMenuStyle.display = "block !important"
    },
    getHideMenu() {
      this.isMenu = false
      this.hideMenuStyle.display = "none !important"
    }
  }
}
</script>
<style lang="scss" scoped>
.header {
  position: fixed;
  top: 0;
  width: 100vw;
  height: 89px;
  z-index: 10000;
  border-bottom: 1px solid rgba($color: #FFFFFF, $alpha: 0.14);

  .menu {
    height: 100%;
    position: relative;
    display: flex;
    justify-content: center;

    .menu-item {
      line-height: 89px;
      color: rgba($color: #FFFFFF, $alpha: 0.7);
      cursor: pointer;
    }

    .menu-item_ {
      color: #FFFFFF;
    }
  }
}

.menu-box {
  display: none;
}

.headers {
  position: fixed;
  top: 0;
  width: 100vw;
  height: 89px;
  z-index: 10000;
  background: #FFFFFF;
  border-bottom: 1px solid rgba($color: #FFFFFF, $alpha: 0.14);
}

.layout {
  max-width: 1440px;
  padding: 0 60px;
  margin: 0 auto;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.left {
  width: 85%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .logo {
    cursor: pointer;
    // width: 137px;
    // height: 46.42px;

    img {
      width: 100%;
      height: 100%;
    }
  }
}

.menu-item-line {
  position: absolute;
  bottom: -1px;
  width: 43px;
  height: 3px;
  background: #DB2733;
}

.menu {
  font-size: 16px;


  .menu-item {
    margin-right: 67px;
    cursor: pointer;
    display: flex;
    justify-content: center;
  }

  .menu-item:last-child {
    margin-right: 0;
  }
}

.right {
  display: flex;
  height: 90px;
  align-items: center;
  position: relative;

  // justify-content: center;
  img {
    cursor: pointer;
  }

  .interpret-icon {
    margin-left: 25px;
    width: 24px;
    height: 24px;
  }

  .seach {
    position: absolute;
    width: 350px;
    top: 100%;
    right: 0;
    padding: 10px;
    box-sizing: border-box;
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: space-between;
    align-items: center;

    >>>.el-input {
      border-radius: 0 !important;
    }

    >>>.el-button {
      border-radius: 0 !important;
    }
  }
}

@media screen and (max-width:767px) {

  .logo {
    width: 120px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .left {
    // flex: 1 !important;
    width: 120px !important;
    height: auto;
  }

  .right {
    height: auto;

    .seach {
      // display: none;
      right: 27px;
    }

  }


  .layout {
    // width: 100%;
    height: 100%;
    padding: 0 15px !important;
    margin: 0 !important;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .menu-box {
    display: block !important;
    display: flex !important;
    width: 20px;
    // margin-right: 30px;
    align-items: center;

    img {
      width: 20px;
      height: 20px;
      margin: auto 0;
    }
  }

  .seach-icon {
    display: none;
  }

  .interpret-icon {
    display: none;
  }

  .menu {
    display: none !important;
    position: fixed !important;
    left: 0;
    bottom: 0;
    right: 0;
    top: 90px;
    background: #FFFFFF;
    z-index: 10000;
    opacity: 1 !important;

    .menu-item {
      line-height: 89px !important;
      color: red !important;
    }

    ul {
      display: block !important;
      text-align: center;
      margin-block-start: 0 !important;
      margin-block-end: 0 !important;
      padding-inline-start: 0 !important;

      li {
        width: 100%;
        display: block !important;
        color: #3333 !important;
      }

      p {
        // opacity: 1 !important;
        width: 100%;
        color: #000000 !important;
      }
    }
  }
}</style>



// WEBPACK FOOTER //
// src/components/header.vue